const TEXT_PREVIEW_MAX_CHARS = 80

// Workspace text entries have no filename, so the body itself is the selectable label.
// Collapse whitespace to a single line and bound the length so it fits a picker row.
export function textPreview(text: string): string {
  const collapsed = text.replace(/\s+/g, ' ').trim()
  if (collapsed.length === 0) return '(empty text)'
  if (collapsed.length <= TEXT_PREVIEW_MAX_CHARS) return collapsed
  return `${collapsed.slice(0, TEXT_PREVIEW_MAX_CHARS).trimEnd()}…`
}
